import {AnyEvent, JOB_SECTION_REORDERED, JobSectionReorderedEvent} from '../type';

export default function jobSectionReordered(payload: JobSectionReorderedEvent['payload']): AnyEvent {
  return {
    type: JOB_SECTION_REORDERED,
    payload,
  }
}